(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["days-log"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('days-log-app')) return;
  class DaysLogApp extends HTMLElement {
    connectedCallback() {
      if (this.booted) return;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        queueMicrotask(() => this.init());
      }
    }
    init() {
      if (this.booted || !this.isConnected) return;
      const root = this;
      const habit = root.querySelector('[data-habit]');
      const start = root.querySelector('[data-start]');
      const days = [...root.querySelectorAll('[data-day]')];
      if (!habit || !start || days.length !== 21) return;
      this.booted = true;
      const key = root.dataset.key;
      const campaignStart = '2026-10-19';
      const empty = () => ({ habit: '', start: campaignStart, days: Array(21).fill(false) });
      let state = empty(), storageOK = true;
      const validDate = value => {
        if (value === '') return true;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
        const date = new Date(value + 'T12:00:00');
        return !Number.isNaN(date.getTime()) && date.getFullYear() === Number(value.slice(0,4)) && date.getMonth()+1 === Number(value.slice(5,7)) && date.getDate() === Number(value.slice(8,10));
      };
      const validate = value => value && typeof value.habit === 'string' && value.habit.length <= 240 && typeof value.start === 'string' && validDate(value.start) && Array.isArray(value.days) && value.days.length === 21 && value.days.every(day => typeof day === 'boolean');
      try {
        const saved = localStorage.getItem(key);
        if (saved) {
          try { const value = JSON.parse(saved); if (validate(value)) state = {habit:value.habit,start:campaignStart,days:[...value.days],shareDay:Number.isInteger(value.shareDay)&&value.shareDay>=1&&value.shareDay<=21?value.shareDay:Math.max(1,value.days.lastIndexOf(true)+1)}; } catch (e) { /* A damaged saved log starts fresh without disabling interaction. */ }
        }
      } catch (e) { storageOK = false; }
      const labelFor = index => {
        if (!state.start) return '';
        const date = new Date(state.start + 'T12:00:00');
        date.setDate(date.getDate() + index);
        return date.toLocaleDateString('en-AU', {day:'numeric',month:'short'});
      };
      function render() {
        if (habit.value !== state.habit) habit.value = state.habit;
        if (start.value !== state.start) start.value = state.start;
        const count = state.days.filter(Boolean).length;
        root.querySelector('[data-count]').textContent = count + ' / 21 days completed';
        root.querySelector('[data-progress]').value = count;
        days.forEach((button, index) => {
          button.setAttribute('aria-pressed', String(state.days[index]));
          button.querySelector('[data-date]').textContent = labelFor(index);
          button.setAttribute('aria-label', 'day ' + (index+1) + (labelFor(index) ? ', '+labelFor(index) : '') + ', ' + (state.days[index] ? 'completed' : 'not completed'));
        });
        root.querySelector('[data-save]').textContent = storageOK
          ? 'saved on this device. use the same browser or home screen icon each day. your daily ticks aren’t sent to days.'
          : 'this browser cannot save your log. your ticks still work while this page is open. save a backup or print / save as pdf before leaving.';
      }
      function persist() {
        try { localStorage.setItem(key, JSON.stringify(state)); storageOK = true; }
        catch (e) { storageOK = false; }
        render();
      }
      habit.addEventListener('input', () => {state.habit=habit.value;persist();});
      const storyButton=root.querySelector('[data-story-open]');
      if(storyButton){
        const dialog=root.querySelector('[data-story-dialog]'),preview=root.querySelector('[data-story-preview]'),status=root.querySelector('[data-story-status]');
        const saveButton=root.querySelector('[data-story-save]'),download=root.querySelector('[data-story-download]'),checker=root.querySelector('[data-story-checker]');
        let storyURL=null,storyFile=null,generation=0;
        function resetStory(){
          storyFile=null;saveButton.disabled=true;download.hidden=true;download.removeAttribute('href');preview.hidden=true;checker.hidden=true;preview.removeAttribute('src');
          if(storyURL){URL.revokeObjectURL(storyURL);storyURL=null;}
        }
        function supportsFileSharing(){
          try{return Boolean(storyFile&&navigator.share&&navigator.canShare&&navigator.canShare({files:[storyFile]}));}catch(e){return false;}
        }
        saveButton.addEventListener('click',async()=>{
          if(!storyFile)return;
          if(!supportsFileSharing()){
            download.click();status.textContent='your transparent png download has started. check your downloads or files app.';return;
          }
          saveButton.disabled=true;
          try{
            // Called directly from a fresh tap, after the PNG has finished generating.
            await navigator.share({files:[storyFile]});
            status.textContent='if you selected save image, check photos for your calendar. the png file contains a transparent background.';
          }catch(e){
            status.textContent=e.name==='AbortError'?'save cancelled. tap save png to photos to try again.':'this browser couldn’t open the save menu. use download png file, or open this page in safari.';
          }finally{saveButton.disabled=!storyFile;}
        });
        dialog.addEventListener('close',()=>{generation++;resetStory();});
        // Indexed PNG with an explicit transparent palette entry. No photo/background is encoded.
        function encodeTransparentPNG(imageData,width,height){
          const bytes=imageData.data,indices=new Uint8Array((width+1)*height);
          const palette=new Uint8Array(256*3),alpha=new Uint8Array(256);
          // Entry 0 is fully transparent. Entries 1–127 are cream, 128–254 are white.
          for(let level=1;level<=127;level++){
            let index=level;palette.set([243,238,223],index*3);alpha[index]=Math.round(level*255/127);
            index=127+level;palette.set([255,255,255],index*3);alpha[index]=Math.round(level*255/127);
          }
          for(let y=0;y<height;y++){
            const row=y*(width+1);indices[row]=0;
            for(let x=0;x<width;x++){
              const p=(y*width+x)*4,a=bytes[p+3];
              if(a===0){indices[row+x+1]=0;continue;}
              const level=Math.max(1,Math.round(a*127/255));
              const white=bytes[p]+bytes[p+1]+bytes[p+2]>741;
              indices[row+x+1]=(white?127:0)+level;
            }
          }
          const table=new Uint32Array(256);
          for(let n=0;n<256;n++){let c=n;for(let k=0;k<8;k++)c=(c&1)?0xedb88320^(c>>>1):c>>>1;table[n]=c>>>0;}
          function chunk(type,data){
            const result=new Uint8Array(data.length+12),view=new DataView(result.buffer);view.setUint32(0,data.length);
            for(let i=0;i<4;i++)result[4+i]=type.charCodeAt(i);result.set(data,8);
            let crc=0xffffffff;for(let i=4;i<8+data.length;i++)crc=table[(crc^result[i])&255]^(crc>>>8);
            view.setUint32(result.length-4,(crc^0xffffffff)>>>0);return result;
          }
          // Portable zlib stream using stored DEFLATE blocks; no external encoder or browser compression API.
          const blocks=Math.ceil(indices.length/65535),zlib=new Uint8Array(2+indices.length+blocks*5+4);
          zlib.set([0x78,0x01]);let offset=2;
          for(let p=0;p<indices.length;){const length=Math.min(65535,indices.length-p),last=p+length===indices.length;zlib[offset++]=last?1:0;zlib[offset++]=length&255;zlib[offset++]=length>>>8;const inverted=(~length)&65535;zlib[offset++]=inverted&255;zlib[offset++]=inverted>>>8;zlib.set(indices.subarray(p,p+length),offset);offset+=length;p+=length;}
          let s1=1,s2=0;for(let i=0;i<indices.length;i++){s1=(s1+indices[i])%65521;s2=(s2+s1)%65521;}
          new DataView(zlib.buffer).setUint32(offset,((s2<<16)|s1)>>>0);
          const header=new Uint8Array(13),view=new DataView(header.buffer);view.setUint32(0,width);view.setUint32(4,height);header[8]=8;header[9]=3;
          return new Blob([new Uint8Array([137,80,78,71,13,10,26,10]),chunk('IHDR',header),chunk('sRGB',new Uint8Array([0])),chunk('PLTE',palette),chunk('tRNS',alpha),chunk('IDAT',zlib),chunk('IEND',new Uint8Array(0))],{type:'image/png'});
        }
        
        async function prepareStory(){
          const current=++generation;resetStory();status.textContent='creating your transparent png (v2)…';
          const outline=true;
          if(!root.dataset.storyLogo){status.textContent='days needs to add the logo in the page settings before the image is ready.';return;}
          try{
            const logo=await new Promise((resolve,reject)=>{const image=new Image();image.crossOrigin='anonymous';image.onload=()=>resolve(image);image.onerror=()=>reject(Error('logo unavailable'));image.src=root.dataset.storyLogo;});
            if(current!==generation)return;
            const canvas=document.createElement('canvas');canvas.width=1080;canvas.height=1080;
            const ctx=canvas.getContext('2d',{alpha:true});if(!ctx)throw Error('canvas unavailable');
            // Always keep the canvas transparent; no background photo, colour or CSS is baked into the PNG.
            ctx.clearRect(0,0,canvas.width,canvas.height);
            const cream='#f3eedf';ctx.strokeStyle=cream;ctx.fillStyle=cream;ctx.textAlign='center';ctx.textBaseline='middle';
            ctx.font='700 31px Arial, sans-serif';ctx.fillText('21 DAYS TO FORM A HABIT',540,outline?50:120);
            const chosen=state.shareDay||Math.max(1,state.days.lastIndexOf(true)+1);ctx.font='700 43px Arial, sans-serif';ctx.fillText('DAY '+String(chosen).padStart(2,'0')+' / 21',540,outline?170:250);
            const cell=112,gap=14,left=106,top=outline?270:345;
            ['M','T','W','T','F','S','S'].forEach((name,i)=>{ctx.font='600 19px Arial, sans-serif';ctx.fillText(name,left+i*(cell+gap)+cell/2,top-30);});
            for(let i=0;i<21;i++){
              const x=left+(i%7)*(cell+gap),y=top+Math.floor(i/7)*(cell+gap);
              ctx.lineWidth=i===chosen-1?6:2;ctx.strokeRect(x,y,cell,cell);
              ctx.font='500 26px Arial, sans-serif';ctx.fillText(String(i+1),x+cell/2,y+cell/2);
              if(state.days[i]){ctx.lineWidth=3;ctx.beginPath();ctx.moveTo(x+18,y+18);ctx.lineTo(x+cell-18,y+cell-18);ctx.moveTo(x+cell-18,y+18);ctx.lineTo(x+18,y+cell-18);ctx.stroke();}
            }
            // Use the original transparent logo artwork; crop its existing transparent margins.
            const logoWidth=350,logoHeight=logoWidth*(750/1938);
            ctx.drawImage(logo,logo.naturalWidth*(55/2048),logo.naturalHeight*(649/2048),logo.naturalWidth*(1938/2048),logo.naturalHeight*(750/2048),(1080-logoWidth)/2,outline?805:1630,logoWidth,logoHeight);
            // Fail rather than offer an accidentally flattened export.
            if(ctx.getImageData(0,0,1,1).data[3]!==0)throw Error('background is not transparent');
            const pixels=ctx.getImageData(0,0,canvas.width,canvas.height);
            const blob=encodeTransparentPNG(pixels,canvas.width,canvas.height);
            if(current!==generation)return;
            if(blob.type!=='image/png')throw Error('png unavailable');
            storyFile=new File([blob],'days-transparent-v2-day-'+String(chosen).padStart(2,'0')+'.png',{type:'image/png'});
            storyURL=URL.createObjectURL(storyFile);preview.width=1080;preview.height=1080;preview.src=storyURL;preview.hidden=false;checker.hidden=false;
            download.href=storyURL;download.download=storyFile.name;download.hidden=false;saveButton.disabled=false;
            saveButton.textContent=supportsFileSharing()?'save png to photos':'save png file';
            status.textContent=supportsFileSharing()?'tap save png to photos, then choose save image in your phone’s menu. the checkerboard is only a preview and is not in the file.':'use save png file to download the transparent original. the checkerboard is only a preview and is not in the file.';
          }catch(e){if(current===generation)status.textContent='we couldn’t create the image. reload in safari or chrome and try again.';}
        }
        storyButton.addEventListener('click',()=>{dialog.showModal();prepareStory();});
        root.querySelector('[data-story-close]').addEventListener('click',()=>{dialog.close();});
      }

      // The campaign start is fixed for everyone; there is no editable date field.
      root.addEventListener('click', event => {
        const button = event.target.closest('[data-day]');
        if (!button || !root.contains(button)) return;
        const index = Number(button.dataset.day)-1;
        if (!Number.isInteger(index) || index < 0 || index > 20) return;
        state.days[index] = !state.days[index];
        state.shareDay=state.days[index]?index+1:Math.max(1,state.days.lastIndexOf(true)+1);
        persist();
      });
      root.querySelector('[data-reset]').addEventListener('click', () => {
        if (window.confirm('clear your commitment and all 21 ticks?')) {state=empty();persist();}
      });
      root.querySelector('[data-export]').addEventListener('click', () => {
        const data = new Blob([JSON.stringify({format:'days-log-v1',key,...state},null,2)], {type:'application/json'});
        const url = URL.createObjectURL(data), link = document.createElement('a');
        link.href=url;link.download='days-log-backup.json';document.body.appendChild(link);link.click();link.remove();
        setTimeout(()=>URL.revokeObjectURL(url),10000);
        root.querySelector('[data-backup-status]').textContent='save the backup file to your device. use restore backup to bring it into another browser or home screen app.';
      });
      const fileInput = root.querySelector('[data-file]');
      root.querySelector('[data-import]').addEventListener('click', () => fileInput.click());
      fileInput.addEventListener('change', async () => {
        const file=fileInput.files[0],status=root.querySelector('[data-backup-status]');
        if (!file) return;
        try {
          if (file.size > 20000) throw new Error('large file');
          const value=JSON.parse(await file.text());
          if (value.format !== 'days-log-v1' || !validate(value)) throw new Error('invalid file');
          if (value.key !== key) {status.textContent='this backup belongs to another challenge. choose a backup for this challenge.';return;}
          if (!window.confirm('replace this log with your saved backup?')) return;
          state={habit:value.habit,start:campaignStart,days:[...value.days],shareDay:Number.isInteger(value.shareDay)&&value.shareDay>=1&&value.shareDay<=21?value.shareDay:Math.max(1,value.days.lastIndexOf(true)+1)};persist();
          status.textContent=storageOK?'your backup has been restored and saved.':'your backup has been restored for this visit. this browser cannot save it; keep your backup file.';
        } catch (e) {status.textContent='that file isn’t a valid days log backup. choose a backup saved from this log.';}
        finally {fileInput.value='';}
      });
       function printLog(blank){
  const frame=document.createElement('iframe');frame.title='Printable Days Log';frame.style.cssText='position:fixed;width:1px;height:1px;left:-9999px';document.body.appendChild(frame);const doc=frame.contentDocument;
  doc.open();doc.write('<!doctype html><html><head><title>Days Log</title><style>@page{size:A4 portrait;margin:18mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#252420;margin:0}h1{font-size:52px;line-height:1;margin:24px 0}h2{font-size:24px}p{line-height:1.5}p:not(.eyebrow){text-transform:lowercase}.eyebrow{font-size:11px;letter-spacing:2px}.promise{min-height:65px;border-bottom:1px solid #777;padding:10px 0;white-space:pre-wrap;overflow-wrap:anywhere}.grid{display:grid;grid-template-columns:repeat(7,1fr);gap:8px;margin:30px 0}.day{border:1px solid #999;height:93px;padding:10px;font-size:10px}.day strong{display:block;font-size:22px;margin:5px 0}.footer{margin-top:30px;font-size:12px}</style></head><body><p class="eyebrow">21 DAYS TO FORM A HABIT.</p><h1>YOUR WORD.<br>YOUR WORK.</h1><h2>THE DAYS LOG.</h2><p>MY DAILY COMMITMENT</p><div class="promise"></div><p class="start"></p><div class="grid"></div><p>Tick each day you complete your commitment.<br>Miss a day? Show up again tomorrow.</p><p class="footer">days. / DO AS YOU SAY.</p></body></html>');doc.close();
  doc.querySelector('.promise').textContent=blank?'':state.habit;doc.querySelector('.start').textContent='19 october – 8 november 2026 / day 21: days event';
  for(let i=0;i<21;i++){const cell=doc.createElement('div');cell.className='day';cell.textContent='DAY';const n=doc.createElement('strong');n.textContent=String(i+1);cell.appendChild(n);cell.appendChild(doc.createTextNode((!blank&&state.days[i]?'✓':'□')+' '+labelFor(i)));doc.querySelector('.grid').appendChild(cell)}
  setTimeout(()=>{frame.contentWindow.focus();frame.contentWindow.print();setTimeout(()=>frame.remove(),60000)},250);
 }

      root.querySelector('[data-print]').addEventListener('click',()=>printLog(false));
      root.querySelector('[data-blank]').addEventListener('click',()=>printLog(true));
      render();
      root.querySelectorAll('button[disabled]').forEach(button=>{if(!button.hasAttribute('data-story-save'))button.disabled=false;});
    }
  }
  customElements.define('days-log-app', DaysLogApp);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
